import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import Swal from 'sweetalert2'

export default class Modalregister extends Component {
    constructor(props) {
        super(props);
                this.state = {
                modal: false,

                send_id :'1', //ผู้ลงทะเบียน
                send_type : '', //ประเภท
                namepresent : '', //ผู้นำเสนอ
                send_name : '', //ชื่อบทความ
                major_precent : '', //สาขาที่นำเสนอ
                send_uploadeword1 : null,
                send_uploadepdf1 : null,
                send_uploadeword12 : null,
                send_uploadepdf12 : null,
                send_date1 : '', //  วันที่ส่ง
                send_status : '', //สถานะ ชำระเงิน
                stapat : '0',   //สถานะส่ง

                iduser:'',
                }

                this.handleChange1 = this.handleChange1.bind(this);
                this.handleChange2 = this.handleChange2.bind(this);
                this.handleChange3 = this.handleChange3.bind(this);
                this.handleChange4 = this.handleChange4.bind(this);
                this.handleSubmit = this.handleSubmit.bind(this);


                this.handleChangetype = this.handleChangetype.bind(this);
                this.toggle = this.toggle.bind(this);
                this.handleChangemajor = this.handleChangemajor.bind(this);
                this.handleChangenamepresent = this.handleChangenamepresent.bind(this);
                this.handleChangesend_name = this.handleChangesend_name.bind(this);
                
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.props.selectatf();
}


 componentDidMount() {
       const { iduser } = this.props.iduser
    //   console.log(id_send);
       this.setState({ iduser:this.props.iduser})
    //   setTimeout(() => {
    //     //ภายใน
    //      Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
    //     .then(res => {
    //       console.log(res);
    //     //  this.setState({ bankname: res.data, loading: false })
    //       this.setState({ Expert: res.data})
    //     }) 

    //   }, 0);

  }

//   getExpert() {
//     setTimeout(() => {
//       //ภายใน
//        Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
//       .then(res => {
//         console.log(res);
//       //  this.setState({ bankname: res.data, loading: false })
//         this.setState({ Expert: res.data})
//       }) 
//     }, 0);

// }



  //ปากเปล่าโปสเตอร์
  handleChangetype(event) {    this.setState({send_type: event.target.value});  }
  //ปากเปล่าโปสเตอร์สาขา
  handleChangemajor(event) {    this.setState({major_precent: event.target.value});  }
  //ผู้นำเสนอ
  handleChangenamepresent(event) {    this.setState({namepresent: event.target.value});  }
//ผู้นำเสนอ
  handleChangesend_name(event) {    this.setState({send_name: event.target.value});  }


  handleChange1(event) {    this.setState({send_uploadeword1: event.target.files[0]});  }
  handleChange2(event) {    this.setState({send_uploadepdf1: event.target.files[0]});  }
  handleChange3(event) {    this.setState({send_uploadeword12: event.target.files[0]});  }
  handleChange4(event) {    this.setState({send_uploadepdf12: event.target.files[0]});  }



  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);
   setTimeout(() => {

    const date = new Date();
    const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
    const dates = day+"-"+month+"-"+year ;

      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("idsend", this.props.iduser);
      datafrm.append("send_type", this.state.send_type);
      datafrm.append("namepresent", this.state.namepresent);
      datafrm.append("send_name", this.state.send_name);
      datafrm.append("major_precent", this.state.major_precent);
      datafrm.append("send_uploadeword1", this.state.send_uploadeword1);
      datafrm.append("send_uploadepdf1", this.state.send_uploadepdf1);
      datafrm.append("send_uploadeword12", this.state.send_uploadeword12);
      datafrm.append("send_uploadepdf12", this.state.send_uploadepdf12);
      datafrm.append("send_date1", dates);
      datafrm.append("send_status", this.state.send_status);
      datafrm.append("stapat", this.state.stapat);

  Axios.post("https://edu.kpru.ac.th/conference/PHPAPI/uploadregister.php",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
   })

   .then(res => {
    console.warn(res);
     console.log("response: ", res)
     if (res.data.length !== 0) {
      // this.showitem = true;
       console.log(res)
       console.log(res.data.length) 
    }else{
     // window.location.href = '/'
    }


    if (res.data.status = 'success999') {
     // message.success("อัพโหลไฟล์สำเร็จ")
    //  this.setState({ id_send: ""})
     // window.location.href = '/adminfaculty'
     Swal.fire({
      title: 'เพิ่มบทความสำเร็จ',
      text: "Add success articles",
      icon: 'success',
      showCancelButton: false,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'ตกลง'
    }).then((result) => {
      if (result.isConfirmed) {
        // Swal.fire(
        //   'Deleted!',
        //   'Your file has been deleted.',
        //   'success'
        // )
        this.props.list();
        this.toggle()
      }
    })
    
    }else{
      message.error("อัพโหลไฟล์ไม่สำเร็จ!")
    }

  })



}, 2000);

//window.location.href = '/adminfaculty'
//this.props.updateat();
//this.getExpert()

  }

  

    render() {
        
          console.log(this.state.send_type)
          console.log(this.state.major_precent)
          console.log(this.state.namepresent)
          console.log(this.state.send_name)
          console.log(this.state.send_uploadeword1)


        return (
          
            <MDBContainer className='text-left'>
           <div className='text-center'><MDBBtn color="deep-purple" onClick={this.toggle}><MDBIcon icon="plus-square" />  เพิ่มบทความ</MDBBtn></div> 

            <MDBModal isOpen={this.state.modal} toggle={this.toggle} size="lg">
              <MDBModalHeader toggle={this.toggle}>เพิ่มบทความนำเสนอ</MDBModalHeader>
              <MDBModalBody>
              <div>

           
                            <div className="mb-2">
                            <label><strong>สาขาการนำเสนอ</strong></label>
                            <select className="browser-default custom-select" onChange={this.handleChangemajor}>
                                        <option>------กรุณาเลือกสาขาการนำเสนอ------</option>
                                         <option value="สาขาคณิตศาสตร์" >สาขาคณิตศาสตร์</option>
                                         <option value="สาขาวิทยาศาสตร์ทั่วไปฟิสิกส์ เคมี/ชีวิวิทยา" >สาขาวิทยาศาสตร์ทั่วไปฟิสิกส์ เคมี / ชีวิวิทยา</option>
                                         <option value="สาขาภาษาอังกฤษ" >สาขาภาษาอังกฤษ</option>
                                         <option value="สาขาภาษาไทย" >สาขาภาษาไทย</option>
                                         <option value="สาขาภาษาจีน/ภาษาเกาหลี" >สาขาภาษาจีน / ภาษาเกาหลี</option>
                                         <option value="สาขาการศึกษาปฐมวัย" >สาขาการศึกษาปฐมวัย</option>
                                         <option value="สาขาพลศึกษา/สุขศึกษา" >สาขาพลศึกษา / สุขศึกษา</option>
                                         <option value="สาขาคอมพิวเตอร์ศึกษา นวัตกรรมและเทคโนโลยีทางการศึกษา" >สาขาคอมพิวเตอร์ศึกษา นวัตกรรมและเทคโนโลยีทางการศึกษา</option>
                                         <option value="สาขาสังคมศึกษา/เกษตร คหกรรมศาสตร์" >สาขาสังคมศึกษา/เกษตร คหกรรมศาสตร์</option>
                                         <option value="สาขาการประถมศึกษา" >สาขาการประถมศึกษา</option>
                                         <option value="สาขาการศึกษาพิเศษ" >สาขาการศึกษาพิเศษ</option>
                                         <option value="สาขานาฏศิลป์ ดนตรี ศิลปะ อุตสาหกรรมศิลป์" >สาขานาฏศิลป์ ดนตรี ศิลปะ อุตสาหกรรมศิลป์</option>
                                         <option value="สาขาหลักสูตรและการสอน การบริหารการศึกษา / ครูรักษ์ถิ่น" >สาขาหลักสูตรและการสอน การบริหารการศึกษา</option>
                                         <option value="สาขาจิตวิทยาการศึกษา / วิจัยและประเมินผลทางการศึกษา" >สาขาจิตวิทยาการศึกษา / วิจัยและประเมินผลทางการศึกษา / ครูรักษ์ถิ่น</option>

                            </select>
                            </div>

                            <div className="mb-2">
                            <label><strong>ประเภทการนำเสนอ</strong></label>
                            <select className="browser-default custom-select" onChange={this.handleChangetype}>
                                        <option>------กรุณาเลือกประเภทนำเสนอ------</option>
                                         <option value="1" >นำเสนอแบบปากเปล่า</option>
                                         <option value="2" >นำเสนอแบบโปสเตอร์</option>
                            </select>
                            </div>

                            <div className="mb-2">
                           <label><strong>ผู้นำเสนอ</strong></label>
                           <input className="form-control" onChange={this.handleChangenamepresent} name="name"
                                    value={this.state.namepresent} placeholder="กรุณาระบุผู้นำเสนอ" required />
                            </div>
                  

                           <div className="mb-2">
                           <label><strong>หัวข้องานวิจัย</strong></label>
                           <input className="form-control" onChange={this.handleChangesend_name} name="name"
                                    value={this.state.send_name} placeholder="กรุณาระบุหัวข้องานวิจัย" required />
                            </div>


                            <div className="mb-2">
                            <label><strong>อัพโหลดไฟล์บทความ <MDBIcon icon="file-word" /> .docx</strong></label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange1}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/msword,*,.doc, .docx"
                                    />
                            </div>

                            <div className="mb-2">
                            <label><strong>อัพโหลดไฟล์บทความ <MDBIcon icon="file-pdf" /> .pdf</strong></label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange2}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/pdf,*"
                                    />
                            </div>

                            <div className="mb-2">
                            <label><strong>อัพโหลดไฟล์รับรองบทความ <MDBIcon icon="file-word" /> .docx</strong></label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange3}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/msword,*,.doc, .docx"
                                    />
                            </div>

                            <div className="mb-2">
                            <label><strong>อัพโหลดไฟล์รับรองบทความ <MDBIcon icon="file-pdf" /> .pdf</strong></label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange4}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/pdf,*"
                                    />
                            </div>

                 
              </div>
              
              </MDBModalBody>
              <MDBModalFooter>
                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
                <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn>
              </MDBModalFooter>
            </MDBModal>
          </MDBContainer>
          
        )
    }
}
